<template>
    <residencies-store
        :include="[
            'tenancy'
        ]"
        v-slot="{
            sid,
            is_loading: is_saving,
            data: residency,
            error,
            store,
            forget
        }"
        @success="onSuccess"
    >
        <div class="bg-white rounded shadow">
            <header class="flex items-center px-4 border-b h-18 sm:px-6">
                <h1 class="text-lg font-normal">
                    Add a Tenant
                </h1>
            </header>

            <base-form @submit="store(form)">
                <div class="px-4 pt-6 border-b sm:px-6">
                    <validator-alert :sid="sid" />

                    <form-section>
                        <template slot="title">Tenant</template>
                        <template slot="description">
                            Which tenant would you like to add to a tenancy?
                        </template>

                        <grid-layout>
                            <grid-layout-item class="md:w-1/2">
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="occupant"
                                >
                                    <template slot="label">Tenant</template>

                                    <input-occupant
                                        v-model="form.occupant"
                                        :uuid="$route.query.occupant"
                                        :sid="sid"
                                        :disabled="is_saving"
                                        name="occupant"
                                    />

                                    <template slot="hint">
                                        Do you need to
                                        <router-link
                                            :to="{
                                                name: $router.fix('dashboard.*.occupants.create'),
                                                query: {
                                                    then: 'create-residency',
                                                    tenancy: $route.query.tenancy
                                                }
                                            }"
                                            class="text-blue"
                                        >
                                            create a tenant
                                        </router-link>
                                        first?
                                    </template>
                                </form-item>
                            </grid-layout-item>
                        </grid-layout>
                    </form-section>
                </div>

                <div class="px-4 pt-6 border-b sm:px-6">
                    <form-section>
                        <template slot="title">Tenancy</template>
                        <template slot="description">
                            Which tenancy would you like to add the tenant to?
                        </template>

                        <grid-layout>
                            <grid-layout-item class="md:w-1/2">
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="tenancy"
                                >
                                    <template slot="label">Tenancy</template>

                                    <input-tenancy
                                        v-model="form.tenancy"
                                        :uuid="$route.query.tenancy"
                                        :sid="sid"
                                        :disabled="is_saving"
                                        name="tenancy"
                                    />
                                </form-item>
                            </grid-layout-item>
                        </grid-layout>
                    </form-section>
                </div>

                <base-form-footer
                    class="rounded-b"
                >
                    <base-button
                        :is-loading="is_saving"
                        class="w-full btn-blue md:w-auto"
                    >
                        Add Tenant
                    </base-button>
                </base-form-footer>

                <error-modal
                    v-if="error && $error.is(error, { exclude: [422] })"
                    :error="error"
                />

                <modal-success
                    :is-open="show_created_modal"
                    @close="show_created_modal = false; forget(); reset()"
                >
                    <template slot="heading">Tenant created!</template>

                    <p>
                        Your tenancy has been created and is ready for you to begin
                        adding tenants.
                    </p>

                    <div
                        slot="footer"
                        slot-scope="{ close }"
                        class="flex flex-col md:flex-row-reverse"
                    >
                        <router-link
                            :to="{
                                name: $router.fix('dashboard.*.tenancies.show'),
                                params: {
                                    tenancy: residency.tenancy.uuid
                                }
                            }"
                            class="text-center btn btn-green"
                        >
                            Go to Tenancy
                        </router-link>

                        <button
                            type="button"
                            @click.prevent="close"
                            class="mt-3 text-center btn md:mt-0 md:mr-3"
                        >
                            Add another
                        </button>
                    </div>
                </modal-success>
            </base-form>
        </div>
    </residencies-store>
</template>

<script>
    import InputTenancy from '../../../../components/input-tenancy'
    import InputOccupant from '../../../../components/input-occupant'
    import ResidenciesStore from '../../../../components/residencies-store'

    export default {
        components: {
            InputTenancy,
            InputOccupant,
            ResidenciesStore
        },
        data () {
            return {
                show_created_modal: false,
                form: {
                    tenancy: null,
                    occupant: null
                }
            }
        },
        methods: {
            onSuccess () {
                this.$track(
                    'dashboard.landlords.residencies.create',
                    'form-submission',
                    'A landlord has invited a tenant'
                )

                setTimeout(() => {
                    this.show_created_modal = true
                }, 0)
            },
            reset () {
                this.$validator.reset(this.sid)

                this.form.occupant = null
            }
        }
    }
</script>
